import { render, staticRenderFns } from "./HeadlessBannersAdd.vue?vue&type=template&id=24153b4e&"
import script from "./HeadlessBannersAdd.vue?vue&type=script&lang=ts&"
export * from "./HeadlessBannersAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports